// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2z2x6","choiceBoxes":"toolbarselects_choiceBoxes__1brpM","simpleField":"toolbarselects_simpleField__1FfFN"};